<template>
    <!-- Page header -->
    <div>
        <div class="page-header page-header-light">
            <div class="page-header-content header-elements-md-inline">
                <div class="page-title d-flex">
                    <h4>
                        <span class="font-weight-semibold">Templates</span>
                        <button class="btn btn-primary" @click="adding = true">Add</button>
                    </h4>
                </div>
            </div>
        </div>
        <!-- /page header -->
        <!-- Content area -->
        <div class="content">
            <div class="card">
                <div class="table-responsive" :class="{'loading-mask': loading}">

                    <button @click="load" class="btn btn-primary pull-right" style="margin: 10px">Refresh list</button>
                    <button :disabled="page >= pages" @click="offset = (pages-1)*limit; load()" class="btn btn-primary pull-right" style="margin: 10px">Last page >></button>
                    <button :disabled="page >= pages" @click="nextPage" class="btn btn-primary pull-right" style="margin: 10px">Next page >></button>
                    <button :disabled="true" class="btn btn-primary pull-right" style="margin: 10px">Page: {{page}} / {{pages}} (count: {{count}})</button>
                    <button :disabled="offset <= 0" @click="prevPage" class="btn btn-primary pull-right" style="margin: 10px">
                        << Previous page</button> <button :disabled="offset <= 0" @click="offset = 0; load()" class="btn btn-primary pull-right" style="margin: 10px">
                            << First page</button> <input placeholder="Search by text" style="border: 1px solid grey; margin-top: 10px" type="text" class="col-2 form-control pull-right" v-model="query" />
                            <table class="table table-striped table-xs" style="min-height: 100px">
                                <thead>
                                    <tr>
                                        <th>No.</th>
                                        <th>Name</th>
                                        <th>Tag</th>
                                        <th>Created at</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="r,k in rows">
                                        <td style="width:10px">{{k+1}}</td>
                                        <td>{{r.name}}</td>
                                        <td>{{r.tag}}</td>
                                        <td>{{r.created_at|estTime}}</td>
                                        <td>
                                            <button @click="adding = r._id" class="btn btn-sm btn-primary">Edit</button>
                                        </td>
                                    </tr>
                                    <h2 v-if="rows.length === 0"> </h2>
                                </tbody>
                            </table>
                </div>
            </div>
        </div>
        <!-- /content area -->
        <template-modal v-if="adding" :id="adding" @close="adding = false" @reload="load()" />
        <!-- /content area -->
    </div>
</template>
<script>
let queryDebounce
import moment from 'moment'
import EventBus from '@/event_bus'
import Template from './modal/Template.vue'
export default {
    components: { TemplateModal: Template },
    data() {
        return {
            showUpload: false,


            rows: [],
            loading: true,
            adding: false,
            limit: 25,
            offset: 0,
            count: 0,
            query: null
        }
    },
    watch: {
        query() {

            if (queryDebounce) {
                clearTimeout(queryDebounce)
            }

            queryDebounce = setTimeout(() => {
                this.offset = 0
                this.load()
            }, 500)
        },
    },
    computed: {
        pages() {
            if (this.count <= this.limit) {
                return 1
            }
            console.log(this)
            return Math.ceil(this.count / this.limit)
        },
        page() {
            if (this.offset === 0) {
                return 1
            }
            return (this.offset / this.limit) + 1 || 1
        },
    },
    methods: {
        prevPage() {
            this.offset -= 25
            this.load()
        },
        nextPage() {
            this.offset += 25
            this.load()

        },
        load() {
            this.$api.getReq(`template`, {
                limit: this.limit,
                offset: this.offset,
                query: this.query || ''
            }).then(res => {
                this.rows = res.body.data
                this.count = res.body.count
                this.loading = false
            })
        }
    },
    destroyed() {},
    mounted() {
        this.load()
    }
}
</script>
<style>
.avsquare {
    width: 7px;
    height: 100%;
    float: left;
    cursor: pointer;
    border-left: 1px solid rgba(0, 0, 0, .1);
}

.avsquare:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

.avsquare:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

tbody .btn {
    padding: 3px 11px;
}
</style>


// WEBPACK FOOTER //
// src/components/Template.vue